import React, {Fragment, useEffect, useState} from "react";
import ApiService from "../../../services/ApiService";
import ProgressBar from "@ramonak/react-progress-bar";
import DonSection from "./don-section";
import Counter from "./counter";
import {ConfigProvider, Tabs} from "antd";
import {getCurrencyFormater, getDeviseSymbol} from "../../../i18n";
import {Trans} from "@lingui/react/macro";
import {t} from "@lingui/core/macro";
import {getLayoutDirection, isRtl} from "../../../locales";
import {getPrimaryColor} from "../tokens";

export default function TeamDonSection({context,campagneData,campagneTarget})
{
    const [loading,setLoading]=useState(true)
    const [teams,setTeams]=useState([])


    const getTeams=async ()=>{
        try{
            const res=await ApiService.get("/campagne/teams/"+campagneData.id)
            // Réponse inattendue (réseau mobile instable) : liste vide plutôt qu'un plantage de toute la page.
            setTeams(Array.isArray(res?.data)?res.data:[])
            setLoading(false)
        }catch(e){
            // Échec de l'appel : la section reste masquée, le reste de la campagne s'affiche.
        }
    }

    useEffect(() => {
        getTeams()
    }, [campagneData?.teams?.length]);

    const isMobile=context.isMobile

    if(loading){
        return null
    }

    let progressColor=getPrimaryColor(campagneData.config)

    const formater=new Intl.NumberFormat('fr-FR', { maximumFractionDigits:0 })
    const currencyFormater=getCurrencyFormater(context)


    const teamsSection= (
        <Fragment>
            <span className="title"><Trans>{teams?.length || 0} équipe(s)</Trans></span>
            <div style={{
                display: "flex",
                flexWrap: "wrap",
                columnGap: 30,
                rowGap: 10,
                marginTop:"2rem",
                margin: "1rem",
                width: "100%",
                maxHeight: "70vh",
                overflowY: "scroll",
                overflowX: "hidden"
            }}>
                {teams.filter(i=>!i.hidden).map(t => {

                    const isCount = campagneData.type === "COUNT" || campagneData.type === "PARTNER"

                    const teamTotal = isCount ? t.stats.count.total : t.stats.sum.total
                    const teamCount = t.stats.count.total
                    const percent = Number(t.objectif)>0 ? (teamTotal / t.objectif) * 100 : 0

                    //let donorName = campagneData.config?.donorName || "Donateurs"
                    let donorName = context.getDonorName(formater.format(t.objectif))



                    return (
                        <div key={t.id} style={{
                            display: "flex",
                            flexDirection: "column",
                            width: isMobile ? "90%" : "45%",
                            marginTop:"2rem"
                        }}>

                            <span className="title-link" style={{
                                fontSize: "1.125rem",
                                lineHeight: "1.75rem",
                                fontWeight: 900,
                                marginBottom: "1rem",
                                textTransform: "capitalize",
                            }}>
                                <a href={context.org.BASE_WEB_URL + "/" + t.param}
                                   style={{color: "inherit", textDecoration: "none"}}>{t.label}</a>
                            </span>


                            <ProgressBar
                                customLabel={" "}
                                animateOnRender
                                completed={percent}
                                width={"100%"}
                                height={"0.5rem"}
                                bgColor={progressColor}
                            />
                            <div style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                marginTop: "1rem"
                            }}>
                                    <span style={{fontSize: "1rem"}}>
                                        <span style={{fontWeight: 700}}>
                                        {isCount &&(
                                            <span>{formater.format(teamTotal)}{Number(t.objectif)>0 ? <Fragment> <Trans>sur</Trans> {formater.format(t.objectif)} {donorName}</Fragment> : null}</span>
                                        )}
                                        {!isCount &&(
                                            <span>{currencyFormater(teamTotal)}{Number(t.objectif)>0 ? <Fragment> <Trans>sur</Trans> {currencyFormater(t.objectif)} </Fragment> : null}</span>
                                        )}
                                        </span>
                                    </span>

                                {!isCount && (
                                    <span style={{fontSize: "1rem"}}><span
                                        style={{fontWeight: 700}}>{teamCount}</span> <Trans>Donateur(s)</Trans></span>
                                )}
                            </div>


                            <div style={{
                                marginTop: "1rem",
                                marginBottom: "0.5rem",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                                <a className="team-page-button"
                                   href={context.org.BASE_WEB_URL + "/" + t.param}
                                >
                                    <Trans>voir la page</Trans>
                                </a>
                            </div>


                        </div>
                    )
                })}
            </div>
        </Fragment>
    )

    if (isMobile) {

        const tabs = [
            {
                key: '2',
                label: t`DONS`,
                children: (<DonSection context={context} campagneData={campagneData} campagneTarget={campagneTarget}
                                       forceMobile={true}/>),
            },
            {
                key: '1',
                label: t`ÉQUIPES`,
                children: teamsSection,
            },
        ]

        return (
            <div className={"container"} style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                columnGap: "0.5rem",
                padding: isMobile ? "2rem 1rem" : "2rem 0",
                minHeight: 300
            }}>

                <ConfigProvider
                    direction={getLayoutDirection(context.langValue)}
                    theme={{
                        components: {
                            Tabs: {
                                inkBarColor:"#13A0BB",
                                itemActiveColor:"#13A0BB",
                                itemSelectedColor:"#13A0BB",
                            },
                        }
                    }}
                >
                <Tabs
                    size={"large"}
                    items={tabs}
                />
                </ConfigProvider>
            </div>
        )
    }


    return (
        <div className={"container"} style={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            columnGap: "0.5rem",
            padding: isMobile ? "2rem 1rem" : "2rem 0",
            minHeight: 300,
            marginTop: "2rem",
        }}>

            <div style={{
                display: "flex",
                alignItems: "start",
                flexDirection: "column",
                flex: isMobile ? "auto" : 3
            }}>
                {teamsSection}
            </div>

            <div style={{
                display: "flex",
                flex: isMobile ? "auto" : 1
            }}>
                <DonSection context={context} campagneData={campagneData} campagneTarget={campagneTarget}
                            forceMobile={true}/>
            </div>
        </div>
    )
}
